import { waitingPeriodLabelConfig } from '@zorro/common-utils';
import { YesNo } from '@zorro/types';
import { getPayrollCycleLabel } from '@zorro/web/ui-utils';

import { CompanySetupFormFields } from '../../../CompanySetupForm';
import { AddEmployerStepType } from '../../AddEmployerStep/AddEmployerUtils';
import { ReviewCard } from '../ReviewCard';

type Props = {
  isFinalizationMode: boolean;
  fields: CompanySetupFormFields;
  employerId: string;
  isValid: boolean;
  isDon: boolean;
};

export const CompanySetupCard = ({
  employerId,
  fields,
  isValid,
  isDon,
  isFinalizationMode,
}: Props) => {
  'use no memo';
  const {
    payrollCycle,
    waitingPeriod,
    isApplicableLargeEmployer,
    subEntities,
    subEntities2,
  } = fields;

  const hasSubEntities2 = subEntities2 && subEntities2.length > 0;

  return (
    <ReviewCard
      isDon={isDon}
      isValid={isValid}
      title="Company setup"
      employerId={employerId}
      step={AddEmployerStepType.COMPANY_SETUP}
      items={[
        {
          name: 'Payroll cycle',
          value: payrollCycle && getPayrollCycleLabel(payrollCycle),
          isRequired: isFinalizationMode,
        },
        {
          name: 'Waiting period',
          value: waitingPeriod && waitingPeriodLabelConfig[waitingPeriod],
          isRequired: isFinalizationMode,
        },
        {
          name: 'ALE company',
          value:
            isApplicableLargeEmployer === YesNo.YES
              ? "Yes, it's an ALE company"
              : "No, it's not an ALE company",
          isRequired: isFinalizationMode,
        },
        {
          name: hasSubEntities2 ? 'Sub-entities 1' : 'Sub-entities',
          value: subEntities.join(', '),
          isRequired: false,
        },
        ...(hasSubEntities2
          ? [
              {
                name: 'Sub-entities 2',
                value: subEntities2.join(', '),
                isRequired: false,
              },
            ]
          : []),
      ]}
    />
  );
};
